import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LifeStyleQuestion } from 'src/app/pages/medical-underwriting/model';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Tooltip } from 'src/app/model/tooltip';

@Component({
  selector: 'app-text-only',
  templateUrl: './text-only.component.html',
  styleUrls: ['./text-only.component.scss']
})
export class TextOnlyComponent implements OnInit {

  @Input() question : LifeStyleQuestion;
  @Input() parent :  UntypedFormGroup;
  @Input() controlName : string;
  @Input() pageName: string;
  @Output() textChangeEventEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() onDisplayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit() {
  }
  
  initializeToolTipDateComp(questionObj: LifeStyleQuestion): Tooltip {
    return new Tooltip(questionObj.helpText, '', false);
  }

  displayMobileTooltipReceiver(){
    this.onDisplayMobileTooltipEmitter.emit();
  }
}
